import React from 'react';
import { useParams } from 'react-router';

// types
import { IntegrationSources } from '../types';

// Hooks
import { useUpdateAiSetting } from 'Shared/utils/hooks/use-update-ai-setting';

// Components
import SlackSource from './SlackSource';
import JiraSource from './JiraSource';
import HubspotSource from './HubspotSource';
import AsanaSource from './AsanaSource';
import SalesforceSource from './SalesforceSource';

// Styles
import './InputSources.scss';

const InputSources = () => {
  const { slug } = useParams();
  const { template } = useUpdateAiSetting({ slug });

  const availableIntegrations = template?.defaultDataSourceSlugs || [];

  const baseClassName = 'InputSources';

  return (
    <div className={baseClassName}>
      {availableIntegrations.includes(IntegrationSources.SLACK_AI) && <SlackSource />}
      {availableIntegrations.includes(IntegrationSources.JIRA) && <JiraSource />}
      {availableIntegrations.includes(IntegrationSources.ASANA) && <AsanaSource />}
      {availableIntegrations.includes(IntegrationSources.HUBSPOT) && <HubspotSource />}
      {availableIntegrations.includes(IntegrationSources.SALEFORCE) && <SalesforceSource />}
    </div>
  );
};

export default InputSources;
